import React from 'react';
import ProductPageTemplate from './ProductPageTemplate';
import {
  SalesIcon,
  SalesAndPricing1,
  SalesAndPricing2,
  SalesAndPricing3,
  SalesAndPricing4,
  SalesAndPricing5,
  SalesAndPricing6,

} from '../../assets';

const SalesPage = () => {
  const productData = {
    productName: 'Sales',
    tagline: 'AI-Driven Sales Management for Modern Forwarders',
    metaDescription: 'CRM for freight forwarders: manage inquiries, quotations, rate comparison, and lead pipelines. Accelerate freight sales from first inquiry to closed deal.',
    description: 'Accelerate growth with our comprehensive Sales Hub. Streamline Inquiries, Quotations, and CRM activities while mastering Rate Management for Road, Air, and Ocean freight.',
    icon: SalesIcon,
    features: [
       {
        title: 'Inquiry and Quotation Management',
        description: 'Generate professional quotations quickly and manage customer inquiries efficiently.',
        image: SalesAndPricing3,
      },
      {
        title: 'Lead and Activity Management',
        description: 'Capture, track, and nurture leads with automated follow-ups and activity tracking.',
        image: SalesAndPricing1,
      },
      {
        title: 'Customizable Sales Pipelines',
        description: 'Create custom pipelines that match your sales process and track deals at every stage.',
        image: SalesAndPricing2,
      },
      {
        title: 'Task Tracking and Collaboration',
        description: 'Assign tasks, set reminders, and collaborate with your team on deals.',
        image: SalesAndPricing4,
      },
      {
        title: 'Rate Explorer and Comparison',
        description: 'Compare rates across carriers and routes to offer competitive pricing.',
        image: SalesAndPricing5,
      },
      {
        title: 'Lead Analytics and Insights',
        description: 'Get actionable insights on lead performance, conversion rates, and sales trends.',
        image: SalesAndPricing6,
      },
    ],

  };

  return <ProductPageTemplate {...productData} />;
};

export default SalesPage;
